export const update_exchange_order = `subscription update_exchange_order{
    update_exchange_order{
        id
        transaction_code
        status
        direction
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        count
        fulfilled_count
        type
        limit_price
        activation_price
        validity_start
        validity_end
        deal_price
        reject_reason
        reject_reason_en
        cancel_accepted
        cancel_reject_reason
        cancel_reject_reason_en
    }
}`;
